import axios from 'axios';

import { CLIENT_CODE, urlEncode } from 'utils';

import { parseErplyResponse } from './index';

const { REACT_APP_PARTNER_KEY, NODE_ENV } = process.env;

export const login = async (params) => {
  const clientCode = localStorage.getItem(CLIENT_CODE);
  const baseURL = `https://${clientCode || params.clientCode}.erply.com/api/`;
  const response = await axios({
    baseURL: NODE_ENV === 'development' ? `${baseURL}` : baseURL,
    method: 'POST',
    data: urlEncode({
      ...params,
      request: 'verifyUser',
      partnerKey: REACT_APP_PARTNER_KEY,
    }),
    validateStatus: () => true
  });
  return parseErplyResponse(response);
};

export const cookieLogin = async ({ clientCode }) => {
  const baseURL = `https://${clientCode}.erply.com/api/`;
  const response = await axios({
    baseURL: NODE_ENV === 'development' ? `${baseURL}` : baseURL,
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    withCredentials: true,
    data: urlEncode({
      clientCode,
      request: 'getSessionKeyUser',
      partnerKey: REACT_APP_PARTNER_KEY,
    }),
    validateStatus: () => true,
  });
  return parseErplyResponse(response);
};

export const logout = ({ clientCode, authURL, sessionKey }) =>
  axios({
    baseURL: `${authURL}v1/session`,
    method: 'DELETE',
    headers: { clientCode, sessionKey },
  });
